HuesMdl.directive( "hue", [ '$compile', '$templateCache', '$stateParams', '$location', 'API_URL', function( $compile, $templateCache, $stateParams, $location, API_URL ) {
	return {
		restrict: 'E',
		replace: true,
		template: $templateCache.get('Hues/Main/Templates/_hue.tpl.html'),
		link: function(scope) {
			var neutral_fan_slug = scope.hue.neutral_fan_slug ? '/' + scope.hue.neutral_fan_slug : scope.$parent.hues.neutral_fan_slug ? '/' + scope.$parent.hues.neutral_fan_slug : '' ;

			scope.hue.print_url = API_URL.PRINT + '/' + scope.hue.ID + neutral_fan_slug;

			scope.location = $location;
			scope.$watch( 'location.url()', function( url ) {
				scope.hue.mail_url = $location.$$absUrl;
			});

		}
	}
}]);